// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1U3wP","gfeWrapper":"CalendarEvent_gfeWrapper__38gyN"};